import React from "react";
import MainTemplate from "../../templates/MainTemplate";

const Quotations = () => {
  return (
    <>
      <MainTemplate>
        <div className="page-header-container">
            <h1 className="page-title">Quotations</h1>
            <p className="page-subtitle">Manage and review all your shipment quotations</p>
        </div>
        
        <div className="glass-card p-5 text-center mt-4">
            <div className="d-flex flex-column align-items-center gap-3">
                <div style={{ padding: '20px', background: 'rgba(79, 70, 229, 0.05)', borderRadius: '50%', color: 'var(--primary-color)' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                </div>
                <div>
                    <h3 style={{ fontWeight: 700, color: 'var(--text-main)', marginBottom: '8px' }}>No Quotations Yet</h3>
                    <p className="text-muted mx-auto" style={{ maxWidth: '400px' }}>
                        When you receive quotations for your shipments, they will appear here in a beautiful, organized list.
                    </p>
                </div>
                <button className="btn-premium mt-2">Create New Quote</button>
            </div>
        </div>
      </MainTemplate>
    </>
  );
};

export default Quotations;
